import { getAPIPath } from '@interhyp/platform-request';
export const fetchNotices = async fetchPublic => {
  const path = fetchPublic ? '/v1/notices/public' : '/v1/notices';
  const response = await fetch(`${getAPIPath('platform-frontend-downtime')}${path}`, {
    headers: {
      'Content-Type': 'application/json'
    }
  });
  if (!response.ok) {
    throw new Error(`Could not fetch notices: ${response.status}`);
  }
  const {
    data
  } = await response.json();
  return data;
};